<template>
  <div class="text">
    <!-- 面包屑导航 -->
    <div class="crumbs">
      <div class="crumbs_font left_10">当前位置:</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="crumbs_font"
          ><span @click="jup()">网校首页</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/' }" class="crumbs_font"
          >打卡首页</el-breadcrumb-item
        >
        <!-- 面包屑显示当前训练营 -->
        <el-breadcrumb-item
          class="crumbs_font"
          v-if="detailInfo != null"
          :to="{ path: `/Detail/study/${detailInfo.detail.camp_id}?camp=${detailInfo.detail.camp_id}` }"
          >{{ detailInfo.detail.name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item
          class="crumbs_font"
          v-if="detailInfo != null && detailInfo.study"
          >任务详情</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="card">
      <textCard @info="myinfo($event)"></textCard>
    </div>
    <div class="time">
      <span class="time_font_black">打卡完成条件：</span>
      <!-- 图文打卡 -->
      <span v-if="tuwen" class="colorOrange">
        完成图文题目并将答案拍照上传日记
      </span>
      <!-- 非图文打卡 -->
      <span v-else>
        <span class="colorOrange"> {{ list.endOfDate }} </span>
        <span class="time_font_black">前完成</span>
        <span class="colorOrange">{{ list.pattern_param[3] }}</span>
        <span class="time_font_black"> 题</span>
      </span>
      <span class="status"
        >目前状态：
        <span class="colorOrange" v-if="list.sign_status == 1">已打卡</span>
        <span class="colorOrange" v-else>未打卡</span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import textCard from "@/components/text_child/text_card.vue";
export default {
  data() {
    return {
      lesson_id: "",
      list: {
        pattern_param: [
          {
            value: 0,
          },
        ],
      },
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      // 章节打卡的章节ID参数
      knowledge_id: "",
      // 是否为图文打卡
      tuwen: this.$route.query.tuwen,
    };
  },
  components: {
    textCard,
  },
  mounted() {
    // 获取课程ID
    this.lesson_id = this.$route.params.id;
    // 获取章节打卡的章节ID
    this.knowledge_id = this.$route.query.knowledge_id;
    // 初始化当前刷题状态
    this.myOneOpen(true);
  },
  computed: {
    ...mapState(["oneOpen", "detailMianbao"]),
    detailInfo() {
      if (this.detailMianbao != null) {
        return this.detailMianbao;
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapMutations(["login", "myOneOpen","mydetailMianbao"]),
    // 获取当前课程信息
    getLesson() {
      this.$axios
        .get("/getLesson", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            lesson_id: this.pattern_id,
            knowledge_id: this.knowledge_id,
          },
        })
        .then((doc) => {
          this.list = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    myinfo(event) {
      this.list = event;
    },
    jup() {
      window.location.href = window.location.origin;
    },
  },
  created() {
    // 分销参数
    let distrid = this.$route.query.distrid;
    if (distrid != null) {
      sessionStorage.setItem("distrid", distrid);
    } else {
      sessionStorage.removeItem("distrid");
    }
    // 获取登录token以及科目类编由于涉及多次跨域这里暂时注释，上线之后在请求，
    let url = window.location.origin;
    url = url + "/getInfo";
    this.$axios
      .get(url)
      .then((doc) => {
        if (doc.token != null) {
          // this.F5 = false;
          localStorage.setItem("token", doc.token);
          localStorage.setItem("agency_id", doc.agency_id);
          this.login(doc);
        } else {
          localStorage.setItem("agency_id", doc.agency_id);
          localStorage.removeItem("token");
          this.login(doc);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // 判断用户是否报名，防止未报名用户非法进入
    this.$axios
      .get("/getCampDetail", {
        params: {
          token: localStorage.getItem("token"),
          agency_id: localStorage.getItem("agency_id"),
          camp_id: this.$router.app.$route.query.camp,
        },
      })
      .then((doc) => {
        if (!doc.is_apply) {
          alert("同学，登录并且报名才能学习噢~~~~~");
          var campID = this.$router.app.$route.query.camp;
          if (campID != null) {
            if (sessionStorage.getItem("distrid") != null) {
              this.$router.push({
                path:
                  `/Detail/apply/${campID}` +
                  "&distrid=" +
                  sessionStorage.getItem("distrid"),
              });
            } else {
              this.$router.push({ path: `/Detail/apply/${campID}` });
            }
          }
        }
        this.mydetailMianbao({ detail: doc.detail, study: true });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="less" scoped>
//   面包屑导航
.crumbs {
  margin: 2rem 0 1.125rem 0;
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  .crumbs_font {
    cursor: pointer;
  }
  .crumbs_font,
  .is-link {
    font-size: 0.75rem;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #9e9f9b;
  }
  .left_10 {
    margin-right: 0.625rem;
  }
  /deep/ .el-breadcrumb {
    .el-breadcrumb__inner {
      font-size: 0.75rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #9e9f9b;
    }
    .el-breadcrumb__inner:hover {
      color: #e9665f;
    }
    .crumbs_font:last-child {
      .el-breadcrumb__inner {
        color: #e9665f;
      }
    }
  }
}

.text {
  margin: auto;
  width: 76.6875rem;
  height: auto;
  .card {
    margin: 2rem 0 1.5625rem 0;
    padding: 2.6875rem;
    width: 76.6875rem;
    height: 26.125rem;
    background: #ffffff;
    box-shadow: 0px 0.125rem 0.375rem 0px rgba(212, 214, 216, 0.3);
    border-radius: 0.1875rem;
    /deep/ .textCard {
      margin-top: 0;
    }
  }
  .time {
    margin-bottom: 17rem;
    width: 76.625rem;
    height: 3.8125rem;
    background: #f7f0e7;
    border: 0.3125rem solid #fffcf6;
    border-radius: 0.375rem;
    background: #f7f0e7;
    font-size: 1rem;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #524546;
    text-align: center;
    line-height: 3.3125rem;
    // .time_font_black {
    // }
  }
  .status {
    margin-left: 0.625rem;
  }
}
</style>